/**
 * AdsBlock Component
 * Google AdSense ad placement with consent management
 */

'use client';

import { useEffect, useState } from 'react';

interface AdsBlockProps {
  slot: string;
  format?: 'auto' | 'rectangle' | 'vertical' | 'horizontal';
  className?: string;
}

export default function AdsBlock({ slot, format = 'auto', className = '' }: AdsBlockProps) {
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    // Check cookie consent
    const consent = localStorage.getItem('cookie_consent');
    setHasConsent(consent === 'accepted');

    // Load AdSense script if consent given
    if (consent === 'accepted' && typeof window !== 'undefined') {
      try {
        ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
      } catch (err) {
        console.error('AdSense error:', err);
      }
    }
  }, []);

  if (!hasConsent || !process.env.NEXT_PUBLIC_ADSENSE_CLIENT) {
    return null;
  }

  return (
    <div className={`ads-container ${className}`}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={process.env.NEXT_PUBLIC_ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}

